<template>
  <div :class="classes">
    <wt-re-request-tip message="列表获取失败"
        :reLoad="load"
        :styles="'top:0;left:0;right:0;bottom:40px;'"
        v-show="isShowReloadTip">
    </wt-re-request-tip>
    <p v-if="showLoading" v-loading="loading" :class="$style['loading_box']"></p>
    <p v-if="isShowNoMore" :class="$style['finished_tip']">
        —————— 加载完成 ———————
    </p>

   <!-- <slot name="no-more" v-if="isShowNoMore"></slot> -->
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'wt-infinite-loading'

export default {
  name: 'wt-infinite-loading',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    distance: {
      type: [String, Number],
      default: 100
    },
    forceWrapper: {
      type: String,
      required: true
    },
    parentDom: {
      type: String
    },
    onRequestData: {
      type: Function
    },
    dataProp: {
      type: String
    }
  },
  data () {
    return {
      loading: false,
      targetDom: this.getTargetDom,
      page: 0,
      isShowNoMore: false,
      isShowReloadTip: false,
      currentData: [],
      showLoading: false
    }
  },
  methods: {
    getTargetDom () {
      this.$nextTick(() => {
        return this.getScrollParent(document.querySelector(this.parentDom))
      })
    },
    load () {
      if (this.isShowNoMore) {
        this.showLoading = false
      } else {
        this.showLoading = true
        this.loading = true
        this.lodeRequestData()
      }
    },
    lodeRequestData () {
      let targetPage = this.isShowReloadTip ? 0 : this.page++
      this.onRequestData && this.onRequestData(targetPage, (data) => {
        let props = this.dataProp ? data[this.dataProp] : data
        console.log('props', props)
        if (props.length) {
          this._fullData(props)
        } else {
          this.showNoMore()
        }
        // this.$emit('updateLoading', false)
        this.loading = false
      })
    },
    // 覆盖当前数据
    _fullData (data) {
      if (this._check(data)) {
        this.currentData = this.currentData.concat(data)
        this.isShowReloadTip = false
      }
    },
    // 检查传入的数据是否符合要求（数组）
    _check (data) {
      if (Array.isArray(data)) {
        return true
      } else {
        console.warn('列表数据必须为数组！')
        return false
      }
    },
    showReTry () {
      this.isShowReloadTip = true
      this.loading = false
    //   this.$emit('updateLoading', false)
    },
    getScrollParent (elm = document) {
      let result

      if (typeof this.forceWrapper === 'string') {
        result = elm.querySelector(this.forceWrapper) // 就是这里 用的是原生的 query
      }
      if (!result) {
        if (elm.tagName === 'BODY') {
          result = window
        } else if (!this.forceWrapper && ['scroll', 'auto'].indexOf(getComputedStyle(elm).overflowY) > -1) {
          result = elm
        } else if (elm.hasAttribute('infinite-wrapper') || elm.hasAttribute('data-infinite-wrapper')) {
          result = elm
        }
      }

      return result || this.getScrollParent(elm.parentNode)
    },
    getData () {
      let sign = Number(this.distance)
      let scrollDistance = this.targetDom.scrollHeight - this.targetDom.scrollTop - this.targetDom.clientHeight
      if (scrollDistance <= sign) {
        this.load()
      }
    },
    showNoMore () {
      this.isShowNoMore = true
      this.showLoading = false
    },
    reset () {
      this.isShowNoMore = false
      this.loading = false
      this.page = 0
      this.isShowReloadTip = false
      this.currentData = []
      this.showLoading = false
      this.load()
    }
  },
  mounted () {
    this.load()
    this.targetDom = this.getScrollParent(document.querySelector(this.parentDom))
    this.targetDom.addEventListener('scroll', this.getData)
  },
  beforeDestory () { // 解绑事件监听
    this.targetDom.removeEventListener('scroll', this.getData)
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.loading_box{
  height: 30px;
}
.finished_tip{
   text-align: center;
}
</style>
